import React from 'react';
import PropTypes from 'prop-types';
import { ConfigContext } from './ConfigContext';
import configShape from './configShape';


export const ConfigProvider = ({ config, children }) => (
    <ConfigContext.Provider value={{ config }}>
        {children}
    </ConfigContext.Provider>
);

ConfigProvider.propTypes = {
    config: configShape,
    children: PropTypes.element.isRequired,
};

export default ConfigProvider;
